import { render, staticRenderFns } from "./report-outstanding-balance.vue?vue&type=template&id=7c2b1d8c&"
import script from "./report-outstanding-balance.vue?vue&type=script&lang=js&"
export * from "./report-outstanding-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports